"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.excludedOrIncludedOptions = exports.ExcludedOrIncluded = exports.yesNoUnknownOptions = exports.YesNoUnknown = exports.ProgramType = void 0;
var ProgramType;
(function (ProgramType) {
    ProgramType["COMMERCIAL_PROPERTY_AND_CASUALTY"] = "COMMERCIAL_PROPERTY_AND_CASUALTY";
    ProgramType["PERSONAL_PROPERTY_AND_CASUALTY"] = "PERSONAL_PROPERTY_AND_CASUALTY";
    ProgramType["BOND"] = "BOND";
})(ProgramType = exports.ProgramType || (exports.ProgramType = {}));
var YesNoUnknown;
(function (YesNoUnknown) {
    YesNoUnknown["UNKNOWN"] = "UNKNOWN";
    YesNoUnknown["YES"] = "YES";
    YesNoUnknown["NO"] = "NO";
})(YesNoUnknown = exports.YesNoUnknown || (exports.YesNoUnknown = {}));
exports.yesNoUnknownOptions = [
    { label: 'Unknown', value: YesNoUnknown.UNKNOWN },
    { label: 'Yes', value: YesNoUnknown.YES },
    { label: 'No', value: YesNoUnknown.NO },
];
var ExcludedOrIncluded;
(function (ExcludedOrIncluded) {
    ExcludedOrIncluded["EXCLUDED"] = "EXCLUDED";
    ExcludedOrIncluded["INCLUDED"] = "INCLUDED";
})(ExcludedOrIncluded = exports.ExcludedOrIncluded || (exports.ExcludedOrIncluded = {}));
exports.excludedOrIncludedOptions = [
    { label: 'Included', value: ExcludedOrIncluded.INCLUDED },
    { label: 'Excluded', value: ExcludedOrIncluded.EXCLUDED },
];
//# sourceMappingURL=common.js.map